import React, { useState } from 'react'
import { useChatContex } from '../../../contex/ChatContex'
import { Box, styled } from '@mui/material'
import {Chat as MessageIcon} from '@mui/icons-material';
import HeaderMenu from './HeaderMenu';
import Infodrawer from '../../Drawer/Infodrawer';





const Image=styled("img")({
   height:"40px",
   width:"40px",
   borderRadius:"50%"
})

const Component= styled(Box)`
height:44px;
background:#ededed;
padding:8px 16px;
display:flex;
align-items:center;
`

const Wraper= styled(Box)`
margin-left:auto;
& *{
    margin-left:2px;
    padding:8px;
    color:#000
};

& :first-child {
   font-size:22px;
   margin-right:8px;
   margin-top:3px;
}

`




function Headers() {
  
const{login}=useChatContex()

const[openDrawer,SetOpneDrwer]=useState(false)

const toggleDrawer=()=>{
    SetOpneDrwer(true)
}

    return (
        <div>
           <Component>
               <Image src={login.picture} onClick={toggleDrawer}></Image>
               <Wraper>
                   <MessageIcon/>
                   <HeaderMenu setOpen={SetOpneDrwer}/>
               </Wraper>
           </Component>
           <Infodrawer open={openDrawer} setOpen={SetOpneDrwer} />
        </div>
    )
}

export default Headers
